import { render, staticRenderFns } from "./WatchFanSupport.vue?vue&type=template&id=3f7f739c&scoped=true"
import script from "./WatchFanSupport.vue?vue&type=script&lang=js"
export * from "./WatchFanSupport.vue?vue&type=script&lang=js"
import style0 from "./WatchFanSupport.vue?vue&type=style&index=0&id=3f7f739c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7f739c",
  null
  
)

export default component.exports